import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { UrlParser } from "@/features/ui/helpers/url-parser";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import useFetcher from "@/utils/use-fetcher";
import { CompanyType } from "@/features/types";
import { LightLineSheetSet } from "@/features/line-sheet-sets/line-sheet-set.types";

export interface CopyLineSheetSetRequest {
  issuedByBoutique: {
    id: number;
  };
}

export interface CopyLineSheetSetResponse extends LightLineSheetSet {}

export interface CopyLineSheetSetParameter {
  by: CompanyType;
  companyId: number;
  lineSheetSetId: number;
}

export const copyLineSheetSetTemplateUrl =
  "/:by/:companyId/line-sheet-sets/:lineSheetSetId/copy";

export const copyLineSheetSetKey: YWRKey<CopyLineSheetSetParameter> = {
  url: (parameter) => {
    return calcUrl(copyLineSheetSetTemplateUrl, parameter);
  },
  method: "post",
};

export function parseCopyLineSheetSetKey(url: string) {
  const urlParser = new UrlParser<CopyLineSheetSetParameter>(
    copyLineSheetSetTemplateUrl,
    {
      by: StringTransformer.parseBy,
      companyId: StringTransformer.parseId,
      lineSheetSetId: StringTransformer.parseId,
    }
  );
  return {
    parameter: urlParser.parse(url),
    method: "post",
  };
}

export default function useCopyLineSheetSet() {
  const fetcher = useFetcher<CopyLineSheetSetRequest, CopyLineSheetSetResponse>();
  return useYWR(copyLineSheetSetKey, fetcher);
}
